export default {"src":"/_next/static/media/payment-bancontact.93fb767e.svg","height":24,"width":36,"blurWidth":0,"blurHeight":0};